/* LiteZupp — global.js
   Lightweight progressive enhancements. No frameworks.
*/

(function () {
  'use strict';

  /* YMM widget — no-op for now; collection filter or app integration will pick this up */
  document.querySelectorAll('[data-ymm-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var year  = form.querySelector('[name="year"]')?.value;
      var make  = form.querySelector('[name="make"]')?.value;
      var model = form.querySelector('[name="model"]')?.value;
      var url = '/collections/all?year=' + encodeURIComponent(year || '') +
                '&make=' + encodeURIComponent(make || '') +
                '&model=' + encodeURIComponent(model || '');
      window.location.href = url;
    });
  });

  /* Variant pickers (PDP) — sync option buttons -> form inputs */
  document.querySelectorAll('[data-variant-picker]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-variant-value]');
      if (!btn) return;
      group.querySelectorAll('[data-variant-value]').forEach(function (b) { b.classList.remove('on'); });
      btn.classList.add('on');
      var hidden = group.querySelector('input[type="hidden"]');
      if (hidden) hidden.value = btn.dataset.variantValue;
    });
  });

  /* Quantity inputs */
  document.querySelectorAll('[data-quantity-button]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById(btn.dataset.quantityButton);
      if (!input) return;
      var v = parseInt(input.value || '1', 10);
      if (btn.dataset.action === 'increase') input.value = v + 1;
      if (btn.dataset.action === 'decrease' && v > 1) input.value = v - 1;
    });
  });

  /* Mobile nav drawer — hamburger toggle */
  var header = document.querySelector('.site-header');
  var navToggle = header && header.querySelector('.nav-toggle');
  if (header && navToggle) {
    var closeNav = function () {
      header.classList.remove('nav-open');
      navToggle.setAttribute('aria-expanded', 'false');
    };
    navToggle.addEventListener('click', function () {
      var open = header.classList.toggle('nav-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    header.querySelectorAll('.nav a').forEach(function (a) {
      a.addEventListener('click', closeNav);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('nav-open')) {
        closeNav();
        navToggle.focus();
      }
    });
  }

  /* Search modal — header search icon opens a popup that submits to the search page */
  var searchModal = document.querySelector('[data-search-modal]');
  if (searchModal) {
    var searchInput = searchModal.querySelector('[data-search-input]');
    var openSearch = function () {
      searchModal.classList.add('is-open');
      searchModal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      if (searchInput) { setTimeout(function () { searchInput.focus(); }, 40); }
    };
    var closeSearch = function () {
      searchModal.classList.remove('is-open');
      searchModal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };
    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
    });
    searchModal.querySelectorAll('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', closeSearch);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchModal.classList.contains('is-open')) { closeSearch(); }
    });
    var sForm = searchModal.querySelector('form');
    if (sForm && searchInput) {
      sForm.addEventListener('submit', function (e) {
        if (!searchInput.value.trim()) { e.preventDefault(); searchInput.focus(); }
      });
    }

    /* ── Instant part-number / bulb lookup ───────────────────────────────
       Resolves a typed part code (LH57, L56RNP) or OE bulb number (1156, 7443,
       H4 …) against assets/xref-index.json. The matching itself lives in
       assets/xref-search.js so this popup and the /search results page return
       the same products in the same order — they used to disagree. The form
       still submits to /search for anything the index can't resolve. */
    var xrefUrl = searchModal.getAttribute('data-xref');
    var resultsBox = searchModal.querySelector('[data-search-results]');
    if (xrefUrl && resultsBox && searchInput && window.LZSearch) {
      var xref = null, xrefLoading = false;
      var esc = window.LZSearch.esc;
      var money = window.LZSearch.money;
      var render = function () {
        if (!xref) return;
        var hit = window.LZSearch.match(xref, searchInput.value, 8);
        if (!hit.handles.length) { resultsBox.innerHTML = ''; resultsBox.classList.remove('is-active'); return; }
        var html = '<div class="search-modal__results-label">' + esc(window.LZSearch.label(hit.tier)) + '</div>';
        hit.handles.forEach(function (hk) {
          var p = xref.products[hk]; if (!p) return;
          html += '<a class="search-xref-row" href="' + p.u + '">' +
                  (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy">' : '<span class="search-xref-noimg"></span>') +
                  '<span class="search-xref-title">' + esc(p.t) + '</span>' +
                  // `pv` = the options differ in price, so show the low end as a
                  // "From". Without it this row promises the cheapest option's
                  // price for the whole product.
                  '<span class="search-xref-price">' + (p.pv ? 'From ' : '') + money(p.p) + '</span></a>';
        });
        resultsBox.innerHTML = html;
        resultsBox.classList.add('is-active');
      };
      var loadXref = function () {
        if (xref || xrefLoading) return;
        xrefLoading = true;
        fetch(xrefUrl).then(function (r) { return r.json(); }).then(function (d) { xref = d; render(); }).catch(function () { xrefLoading = false; });
      };
      searchInput.addEventListener('focus', loadXref);
      searchInput.addEventListener('input', function () { if (!xref) loadXref(); else render(); });
    }
  }
})();
